export enum ChampionshipStatus {
  REGISTRATION = 'REGISTRATION',
  OPEN_IN_PROGRESS = 'OPEN_IN_PROGRESS',
  OPEN = 'OPEN',
  COMPLETED = 'COMPLETED',
}
